import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=029d05ac&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=029d05ac&prod&lang=scss&scoped=true"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=029d05ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029d05ac",
  null
  
)

export default component.exports